import React from 'react'

import { Typography } from "@mui/material"


export default function companyColumn() {

	return {
		name: 'company',
		label: 'Company',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography>{value}</Typography>,
		}
	}
}